/* eslint-disable react/no-unused-class-component-methods */
'use strict';

import React, { Component } from 'react'

import Link  from '@Pure/Link'
import Image from '@Pure/Image'

import _ from 'lodash'

import { safeNumeral, isTrue, formatNum, num, getOnlineType } from '@root/utility'

const { app, qwest, moment, numeral } = window;

moment.locale('fr');

numeral.locale('en');

export default class Cart extends Component
{
	state =
	{
		cart: [],
		artists: [],
		places: []
	};

	componentDidMount ()
	{
		const component = this, props = this.props, state = this.state;

		app.push(
		{
			event: 'cartChange',
			cb: component.handleCartChange
		});

		if (app.state.cart && app.state.cart.length)
		{
			component.handleCartChange();
		}
	}

	componentWillUnmount ()
	{
		const component = this, props = this.props, state = this.state;

		app.delete(
		{
			event: 'cartChange',
			cb: component.handleCartChange
		});
	}

	handleCartChange = () =>
	{
		const component = this, props = this.props, state = this.state;

		component.setState(
		{
			cart: app.state.cart
		});

		if (!state.artists || state.artists.length <= 0)
		{
			component.setState(
			{
				loading: true
			});

			qwest.post('/CMS/getAll', { model: 'artist' })
			.then(function (xhr, response)
			{
				component.setState(
				{
					artists: response.data || [],
					loading: false
				});
			})
			.catch(function (error, xhr, response)
			{
				app.ajaxRedirectLogin(response);

				console.error(error);
			});
		}

		if (state.places && state.places.length > 0)
		{
			return;
		}

		component.setState(
		{
			loading: true
		});

		qwest.post('/CMS/getAll', { model: 'place' })
		.then(function (xhr, response)
		{
			component.setState(
			{
				places: response.data || [],
				loading: false
			});
		})
		.catch(function (error, xhr, response)
		{
			app.ajaxRedirectLogin(response);

			console.error(error);
		});
	}

	changeQty = (e, ref) =>
	{
		const component = this, props = this.props, state = this.state;

		const cart_product = state.cart.find(product => product.cart_price.ref === ref);

		let product = _.cloneDeep(cart_product);

		if (e === 'less')
		{
			product.cart_qty--;
		}
		else if (e === 'more')
		{
			product.cart_qty++;
		}
		else if (e && e.target)
		{
			let qty = numeral(safeNumeral(e.target.value));

			if (product)
			{
				product.cart_qty = qty.format('0');
			}
		}

		if (Number(product.cart_qty) <= 0)
		{
			product.cart_qty = 1;
		}

		app.state.cart.find(function (store_product, i)
		{
			if (store_product.cart_price.ref === ref)
			{
				app.state.cart[i] = _.cloneDeep(product);

				return true;
			}
		});

		qwest.post('/cart/update', { cart: app.state.cart })
		.catch(function (error, xhr, response)
		{
			app.ajaxRedirectLogin(response);

			console.error(error);
		});

		app.emit('cartChange');
	}

	remove = (ref) =>
	{
		const component = this, props = this.props, state = this.state;

		app.state.cart = app.state.cart
		.filter(product => product.cart_price.ref !== ref);

		state.cart = state.cart.filter(product => product.cart_price.ref !== ref);

		qwest.post('/cart/update', { cart: app.state.cart })
		.catch(function (error, xhr, response)
		{
			app.ajaxRedirectLogin(response);

			console.error(error);
		});

		app.emit('cartChange');
	}

	render ()
	{
		const component = this, props = this.props, state = this.state;

		let items = component.state.cart
		.filter(product => Boolean(product.cart_price))
		.map(function (data, key)
		{
			let product = _.cloneDeep(data);

			const online_type = getOnlineType(product.online_type);

			let thumbnail = product.images ? product.images[0] : undefined;

			if (thumbnail)
			{
				thumbnail =
				(
					<Link className="c-cart__item-img" href={ '/accueil/catalogue/' + product.id }>
						<Image src={ thumbnail.url } className="c-cart__item-thumb" />
					</Link>
				);
			}
			else if (product._artist && product._artist.images[0])
			{
				thumbnail =
				(
					<Link className="c-cart__item-img"
						href={ '/accueil/catalogue/' + product.id }>
						<Image src={ product._artist.images[0].url }
							className="c-cart__item-thumb"
						/>
					</Link>
				);
			}

			let short_description;

			if (typeof product.description === 'string')
			{
				short_description = product.description.split('<br>').join('');

				short_description = short_description.split('<p></p>').join('');

				short_description =
				(
					<span className="c-rendered-text" dangerouslySetInnerHTML={
						{ __html: app.truncateToLength(short_description, 200, '..') } } />
				);
			}

			let position = product.cart_price._position;

			if (position)
			{
				position =
				(
					<div className="c-cart__item-info">
						<strong>Placement&nbsp;:</strong>
						{ position.label }
					</div>
				);
			}

			let age = product.cart_price._age;

			if (age)
			{
				age =
				(
					<div className="c-cart__item-info">
						<strong>Tranche d'age&nbsp;:</strong>
						{ age.label }
					</div>
				);
			}

			let price_date = product.cart_price.date;

			if (price_date)
			{
				price_date =
				(
					<div className="c-cart__item-info">
						<strong>Date&nbsp;:</strong>
						{ moment(price_date).format('ddd DD MMM YYYY - HH[h]mm') }
					</div>
				);
			}

			let artist = product._artist;

			if (artist)
			{
				artist =
				(
					<div className="c-cart__item-info">
						<strong>Artiste&nbsp;:</strong>
						{ artist.name }
					</div>
				);
			}

			let ticket_type = product.cart_price._ticket_type;

			if (ticket_type)
			{
				ticket_type =
				(
					<div className="c-cart__item-info">
						<strong>Type de billet&nbsp;:</strong>
						{ ticket_type.label }

						{
							online_type ?
							(
								<div className="c-cart__online-type">
									{ online_type }
								</div>
							)
							: undefined
						}
					</div>
				);
			}

			let validity_date;

			if (product.cart_price?.validity_date)
			{
				validity_date =
				(
					<div className="c-cart__item-info">
						<strong>Valide jusqu'au&nbsp;:</strong>
						{
							moment(product.cart_price.validity_date)
							.format('DD/MM/YYYY')
						}
					</div>
				);
			}

			const date_required = isTrue(product.date_required) ?
			(
				<div className="c-cart__item-info">
					<strong>1er Jour de visite&nbsp;:</strong>
					{
						moment(product.date_required_value)
						.format('DD/MM/YYYY')
					}
				</div>
			)
			: undefined;

			let EC_order_as = product.EC_order_as || undefined;

			if (EC_order_as)
			{
				EC_order_as =
				(
					<div className="c-cart__item-info">
						<strong>Au nom de&nbsp;:</strong>
						{ product.EC_order_as }
					</div>
				);
			}

			let names = product.cart_names;

			if (names instanceof Array)
			{
				names = product.cart_names.reduce(function (string, data)
				{
					if (string !== '')
					{
						string += ', ';
					}

					string += data.firstname + ' ' + data.name + ' (';
					string += moment(data.date).format('DD-MM-YYYY') + ')';

					return string;
				}, '');

				names =
				(
					<div className="c-cart__item-info">
						<strong>Noms renseignés&nbsp;:</strong>
						{ names }
					</div>
				);
			}
			else
			{
				names = undefined;
			}

			let places;

			if (product._places && product._places.length)
			{
				places = product._places.map(function (place, number)
				{
					let city = (place.address.city.slice(0, 1).toUpperCase() +
						place.address.city.slice(1).toLowerCase());

					if (product._places.length > 1)
					{
						if (number > 0) return ', ' + city;

						return city;
					}
					else
					{
						return place.name || city;
					}
				});

				places =
				(
					<div className="c-cart__item-info">
						<svg className="o-svg-icon o-svg-icon--tracker c-cart__item-info-icon">
							<use xlinkHref="/images/icons.svg#svg-icon-tracker" />
						</svg>
						{ places }
					</div>
				);
			}

			let qty =
			(
				<div className="c-cart__item-qty">

					<div className="c-qty c-qty--cart">
						<button type="button" className="c-qty__less"
							onClick={
								function (e)
								{
									component.changeQty('less',
										product.cart_price.ref);
								}
							}>
							-
						</button>

						<input type="number"
							className="c-qty__input"
							value={ product.cart_qty }
							onChange={
								function (e)
								{
									component.changeQty(e, product.cart_price.ref);
								}
							} />

						<button type="button" className="c-qty__more"
							onClick={
								function (e)
								{
									component.changeQty('more', product.cart_price.ref);
								}
							}>
							+
						</button>
					</div>

				</div>
			);

			if (isTrue(product.cart_price.nominative))
			{
				qty =
				(
					<div className="c-cart__item-qty">
						<div className="u-flex u-items-center">
							<div className="c-qty__input">
								x
								{ ' ' }
								{ product.cart_qty }
							</div>
						</div>
					</div>
				);
			}

		// prix en centimes à l'origine
			const unit_price = num(num(product.cart_price.price, 4) / 100);

			const price = num(num(product.cart_qty, 0) * unit_price);

			return (
				<div className="c-cart__item" key={ key }>
					{ thumbnail }

					<div className="c-cart__item-body">
						<h2 className="c-cart__item-title">
							<Link href={ '/accueil/catalogue/' + product.id }>
								{ product.name || product.label || product.title }
							</Link>
						</h2>

						<div className="c-cart__item-description">
							{ artist }
							{ price_date }
							{ date_required }
							{ position }
							{ age }
							{ ticket_type }
							{
								!ticket_type && online_type ?
								(
									<div className="c-cart__online-type">
										{ online_type }
									</div>
								)
								: undefined
							}
							{ names }
							{ validity_date}
							{ EC_order_as }
							{ places }
						</div>
					</div>

					<div className="c-cart__item-actions">

						<button type="button" className="c-btn c-btn--smaller u-margin-bottom-10"
							onClick={
								function (e)
								{
									app.emit('open__CartModal',
									{
										product: product,
										source: 'cart'
									});
								}
							}>
							Modifier
						</button>

						<div className="c-cart__item-pricing">

							{ qty }

							<div className="c-cart__item__price">
								<div className="c-cart__item__price-unit">
									P.U&nbsp;:
									{ ' ' }
									{ formatNum(unit_price, '0.0[.]00') }
									{ ' €' }
								</div>

								<div className="c-cart__item__price-total">
									Total&nbsp;:
									{ ' ' }
									{ formatNum(price, '0,0[.]00') }
									{ ' €' }
								</div>
							</div>

						</div>

						<button type="button" className="c-cart__item-remove"
							onClick={
								function (e)
								{
									component.remove(product.cart_price.ref);
								}
							}>
							Supprimer du panier
						</button>

					</div>

				</div>
			);
		});

		return (
			<div className="c-cart">
				{ items }
			</div>
		);
	}
}